import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import Commercial from "../../shared/Commercial";
import { useProfileData } from "../../hooks/useProfileData";
import { visitEntity } from "../../api/visit";
import { useEntityProfileData } from "../../api/queries/profile/entityProfileQueries";

import EntityTabs from "./Components/EntityTabs";
import EntityHeader from "./Components/EntityHeader";

const Entity = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [showModal, setShowModal] = useState<boolean>(false);

  const { data } = useProfileData();
  const { entityId: entityIdFromCache } = data;
  const { entityId } = useParams();

  const isOwnProfile = !entityId || +entityId === entityIdFromCache;

  useEffect(() => {
    if (!entityId && isOwnProfile) return;
    (async () => await visitEntity(entityId))();
  }, [entityId]);

  const { entityInfo, isEntityInfoLoading, isEntityInfoHasError } = useEntityProfileData({ entityId, isOwnProfile });

  if (isEntityInfoHasError) {
    return <Box>No entity found.</Box>;
  }

  return (
    <Box sx={{ display: "flex", columnGap: "8px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "644px",
        }}
      >
        <EntityHeader
          entityInfo={entityInfo}
          showModal={showModal}
          setShowModal={setShowModal}
          isOwnProfile={isOwnProfile}
          isEntityInfoLoading={isEntityInfoLoading}
        />
        <EntityTabs
          tabValue={tabValue}
          entityInfo={entityInfo}
          handleChangeTabValue={(event: React.SyntheticEvent, newValue: number): void => {
            setTabValue(newValue);
          }}
          isEntityInfoLoading={isEntityInfoLoading}
          isOwnProfile={isOwnProfile}
        />
      </Box>
      <Commercial />
    </Box>
  );
};

export default Entity;
